import { render, staticRenderFns } from "./RealTime.vue?vue&type=template&id=0b997fb2&scoped=true&"
import script from "./RealTime.vue?vue&type=script&lang=js&"
export * from "./RealTime.vue?vue&type=script&lang=js&"
import style0 from "./RealTime.vue?vue&type=style&index=0&id=0b997fb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b997fb2",
  null
  
)

export default component.exports